import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./DiceRoller.module.scss";
import { getSeededRandomNumber } from "../../utils/randomUtils";

const DiceRoller = () => {
  const navigate = useNavigate(); // Hook pro navigaci mezi stránkami
  const [sides, setSides] = useState(6); // Počet stran kostky, výchozí hodnota 6
  const [result, setResult] = useState(null); // Výsledek hodu
  const [rolling, setRolling] = useState(false); // Stav, zda se kostka právě hází
  const [history, setHistory] = useState([]); // Historie posledních hodů

  // Efekt pro načtení počátečního hodu při vstupu na stránku
  useEffect(() => {
    const initRoll = async () => {
      const numSides = parseInt(sides, 10); // Převedení počtu stran na číslo
      // Ověření, zda je počet stran v rozmezí 6–20
      if (numSides >= 3 && numSides <= 20) {
        const roll = (await getSeededRandomNumber(numSides)) + 1; // Generování náhodného čísla
        setResult(roll); // Nastavení výsledku hodu
        setHistory((prev) => [roll, ...prev].slice(0, 10)); // Uložení posledního hodu do historie, omezíme počet na 10
      } else {
        setResult("Neplatný počet stran"); // Pokud je počet stran neplatný, zobrazíme zprávu
      }
    };
    initRoll(); // Zavolání funkce pro inicializaci
  }, [sides]); // Efekt bude spuštěn při změně počtu stran kostky

  // Funkce pro vykonání hodu kostkou
  const handleRoll = async () => {
    const numSides = parseInt(sides, 10); // Převedení počtu stran na číslo
    // Ověření, zda je počet stran v rozmezí 6–20
    if (isNaN(numSides) || numSides < 3 || numSides > 20) {
      setResult("Neplatný počet stran"); // Pokud je počet stran neplatný, zobrazíme zprávu
      return; // Ukončení funkce
    }
    setRolling(true); // Nastavení stavu, že kostka se právě hází
    setTimeout(async () => {
      const roll = (await getSeededRandomNumber(numSides)) + 1; // Generování náhodného čísla
      setResult(roll); // Nastavení výsledku hodu
      setRolling(false); // Ukončení stavu házení
      setHistory((prev) => [roll, ...prev].slice(0, 10)); // Uložení hodu do historie
    }, 1000); // Pauza 1 sekundu před zobrazením výsledku
  };

  return (
    <div className={styles.container}>
      <div className={styles.menu}>
        <button className={styles.backButton} onClick={() => navigate("/")}>
          Zpět
        </button>
        <h3>Kostka</h3>
      </div>
      <div className={styles.content}>
        <div className={styles.controls}>
          <label htmlFor="sides" className={styles.label}>
            Počet stran:
          </label>
          <input
            id="sides"
            type="number"
            value={sides}
            onChange={(e) => setSides(e.target.value)} // Nastavení počtu stran kostky
            min="3"
            max="20"
            className={styles.input}
          />
          <button
            onClick={handleRoll}
            className={styles.rollButton}
            disabled={rolling}
          >
            {rolling ? "Hodí se..." : "Hodit"}{" "}
            {/* Text tlačítka měnící se podle stavu házení */}
          </button>
        </div>
        <div className={styles.display}>
          <p>Aktuální hod:</p>
          <div className={`${styles.dice} ${rolling ? styles.rolling : ""}`}>
            {result} {/* Zobrazení výsledku hodu */}
          </div>
        </div>
        {history.length > 0 && (
          <div className={styles.history}>
            {/* Zde by byla historie hodů, prozatím je to prázdné */}
          </div>
        )}
      </div>
    </div>
  );
};

export default DiceRoller;
